import React from 'react';
import * as Separator from '@radix-ui/react-separator';
import { styled } from '@stitches/react';
import { violet } from '@radix-ui/colors';



const Footer = () => (
  <div>
  <Box css={{ margin: '0 0px' }}>
    <Text css={{ fontWeight: 500 }}>Nabeel M Rizwan</Text>
    
    
<br/>

   <hr></hr>

<br/>
 
 <br/>

 <div className='footer grey'>Copyright © www.nabeel-r.netlify.com</div>
<br/>

 <Text faded>

   <div className='grey'>Blogs: <a faded className='grey' href="https://nabeel-r.vercel.app">https://nabeel-r.vercel.app</a></div>
 </Text> 


<br/>

    <Text faded>
   
      <div className='grey'>Home</div>
     
    </Text> 


   <br/>

  
    <Text faded>
    
      <div className='grey'>About Me</div>
    
    </Text> 
    <br/>

   
    <Text faded>
  
      <div className='grey'>Projects</div>
     
    </Text> 

    <br/>
    
    <Text faded>
   
      <div className='grey' >QRCode</div>
     
    </Text> 
 

  </Box>
  </div>
);

const SeparatorRoot = styled(Separator.Root, {
  backgroundColor: violet.violet6,
  '&[data-orientation=horizontal]': { height: 1, width: '100%' },
  '&[data-orientation=vertical]': { height: '100%', width: 1 },
});

const Box = styled('div', {});
const Flex = styled('div', { display: 'flex' });
const Text = styled('div', {
  color: 'white',
  fontSize: 15,
  lineHeight: '20px',
});

export default Footer;